import { Paper } from "@mui/material"
import type { ReactElement, ReactNode } from "react"
import { twMerge } from "tailwind-merge"

interface SectionContainerProps {
  children?: ReactNode
  className?: string
}

export const SectionContainer = ({ children, className }: SectionContainerProps): ReactElement => {
  return (
    <Paper elevation={0} className={twMerge("flex min-h-0 grow flex-col overflow-hidden bg-white", className)}>
      {children}
    </Paper>
  )
}
